export const MainCard = ({ size, extraClass, children }) => {
  return (
    <div
      className={`${
        size ? size + " m-auto" : "w-full"
      } border-round-xl shadow-2 p-4 my-5 bg-white ${extraClass}`}
    >
      {children}
    </div>
  );
};

export const HighlightFeature = ({ Icon, heading, subHeading }) => {
  return (
    <div className="flex my-3">
      <div></div>
      <div className="">
        <h4 className="my-0">
          {Icon}
          {heading}
        </h4>

        <small className="">{subHeading}</small>
      </div>
    </div>
  );
};

export const ServiceCard = ({ icon, heading, para1, para2 }) => {
  return (
    <div className="col-12 lg:col-6 p-2">
      <div className="text-center shadow-2 border-1 border-gray-300 h-full relative p-3">
        <div className="icon text-3xl text-blue-700 absolute top-0 right-0 left-0 bg-bluegray-500">{icon}</div>
        <h3>{heading}</h3>
        <p>{para1}</p>
        <p>{para2}</p>
      </div>
    </div>
  );
};
